/**
 * Brazilian phone number mask utilities.
 * Format: (XX) X XXXX-XXXX (mobile) or (XX) XXXX-XXXX (landline)
 */

/** Strip all non-digit characters. */
export function toRawDigits(value: string): string {
  return value.replace(/\D/g, '');
}

/** Format raw digits progressively into BR phone format. */
export function formatBRPhone(raw: string): string {
  const digits = toRawDigits(raw).slice(0, 11);
  const len = digits.length;

  if (len === 0) return '';
  if (len <= 2) return `(${digits}`;
  if (len <= 6) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
  if (len <= 10)
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
  return `(${digits.slice(0, 2)}) ${digits.slice(2, 3)} ${digits.slice(3, 7)}-${digits.slice(7)}`;
}

/**
 * Normalize input to raw BR phone digits (max 11).
 * Autofill/paste no mobile costuma incluir o DDI (+55 11 91234-5678 → 13
 * dígitos); um slice cru manteria o "55" como DDD e cortaria o fim do número,
 * salvando telefone errado que ainda passa na validação. Remove o DDI antes
 * de truncar. DDD 55 digitado normalmente (11 dígitos) não é afetado.
 */
export function normalizeBRPhoneDigits(value: string): string {
  let digits = toRawDigits(value);
  if (digits.length > 11 && digits.startsWith('55')) {
    digits = digits.slice(2);
  }
  return digits.slice(0, 11);
}

/** Validate BR phone: 10 digits (landline) or 11 digits (mobile). */
export function isValidBRPhone(raw: string): boolean {
  const digits = toRawDigits(raw);
  return digits.length === 10 || digits.length === 11;
}
